import { render, staticRenderFns } from "./CodAdvanceShops.vue?vue&type=template&id=530d6fbe&scoped=true"
import script from "./CodAdvanceShops.vue?vue&type=script&lang=js"
export * from "./CodAdvanceShops.vue?vue&type=script&lang=js"
import style0 from "./CodAdvanceShops.vue?vue&type=style&index=0&id=530d6fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530d6fbe",
  null
  
)

export default component.exports